export default __webpack_public_path__ + "static/hero-city-breaks-29bc1477bd2e28414d74ede03cfac618.jpg";